<template>
  <BreadcrumbBase :breadcrumbOptions="formattedBreadcrumbs" @onClicked="onClicked">
    <IconChevronRight class="breadcrumb-chevron__icon" />
  </BreadcrumbBase>
</template>

<script lang="ts" setup>
import BreadcrumbBase from '@/design-system/atoms/BreadcrumbBase.vue'
import IconChevronRight from '@/design-system/assets/icons/IconChevronRight.vue'
import { computed, toRefs } from 'vue'
import { BreadcrumbOption } from '@/utils/breadcrumbs'
import { DirectoryItem } from './types'
interface EMITS {
  (e: 'onClicked', option: DirectoryItem)
}
interface Props {
  breadcrumbs: DirectoryItem[]
}
const props = defineProps<Props>()
const { breadcrumbs } = toRefs(props)
const emits = defineEmits<EMITS>()

const formattedBreadcrumbs = computed<BreadcrumbOption[]>(() =>
  breadcrumbs.value.map((item, index) => ({
    id: item.id,
    title: item.name,
    parentId: item.parentId ?? undefined,
    icon: index === 0 ? 'IconSmallPaperClip' : undefined
  }))
)

function onClicked(option: BreadcrumbOption) {
  const selectedItem = breadcrumbs.value.find((item) => item.id === option.id)
  if (selectedItem) {
    emits('onClicked', selectedItem)
  }
}
</script>

<style lang="scss" scoped>
@use '@/design-system/design-tokens/variables.scss';
.breadcrumb-chevron {
  &__icon {
    color: variables.$color-greyscale-content;
  }
}
</style>
